import React from "react"

const CallToAction = ({ lawyerName, onBookAppointment, onSendEnquiry }) => {
  return (
    // <div className="mt-8 bg-gradient-to-r from-[#301555] to-[#411C73] rounded-xl p-6 sm:p-8 text-center">
    //   <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Looking for expert legal advice?</h3>
    //   <p className="text-gray-300 mb-6 max-w-2xl mx-auto text-sm sm:text-base">
 <div className="mt-8 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl p-8 text-center">
      <h3 className="text-2xl font-bold text-gray-800 mb-4">Looking for expert legal advice?</h3>
      <p className="text-gray-600 mb-6 max-w-2xl mx-auto">        
Contact {lawyerName} today to discuss your legal needs and find out how they can help you.
      </p>
<div className="flex flex-wrap justify-center gap-4">      
{/* <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4"> */}
        <button
          onClick={onBookAppointment}
className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-full transition-colors shadow-sm flex items-center"
          // className="px-5 py-2.5 sm:px-6 sm:py-3 bg-gradient-to-r from-[#D80364] to-[#F0654B] hover:opacity-90 active:opacity-95 text-white font-medium rounded-lg transition-colors shadow-md flex items-center justify-center text-sm sm:text-base"
        >
          <svg
className="w-5 h-5 mr-2"
            // className="w-4 h-4 sm:w-5 sm:h-5 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z"
            ></path>
          </svg>
          Book an appointment
        </button>
        <button
          onClick={onSendEnquiry}
className="px-6 py-3 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium rounded-full transition-colors shadow-sm flex items-center"
          // className="px-5 py-2.5 sm:px-6 sm:py-3 bg-purple-900/30 hover:bg-purple-900/40 active:bg-purple-900/50 text-white font-medium rounded-lg transition-colors border border-purple-700/30 flex items-center justify-center text-sm sm:text-base"
        >
          <svg
className="w-5 h-5 mr-2 text-gray-600"
            // className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-gray-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            ></path>
          </svg>
          Send an enquiry
        </button>
      </div>
    </div>
  )
}

export default CallToAction 